import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/axiosInstance";

export const fetchDispositions = createAsyncThunk(
  "dispositions/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/Dispositions");
      return res.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);

export const createDisposition = createAsyncThunk(
  "dispositions/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/Dispositions", payload);
      return res.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);

export const updateDisposition = createAsyncThunk(
  "dispositions/update",
  async ({ id, ...patch }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.patch(`/Dispositions/${id}`, patch);
      return res.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);

export const deleteDisposition = createAsyncThunk(
  "dispositions/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/Dispositions/${id}`);
      return id;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);

export const tagCall = createAsyncThunk(
  "dispositions/tagCall",
  async ({ uniqueId, dispositionId, label, color }, { rejectWithValue }) => {
    try {
      await axiosInstance.put(`/CallDispositions/${uniqueId}`, { dispositionId });
      return { uniqueId, dispositionId, label, color };
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);

export const untagCall = createAsyncThunk(
  "dispositions/untagCall",
  async (uniqueId, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/CallDispositions/${uniqueId}`);
      return uniqueId;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);

const dispositionsSlice = createSlice({
  name: "dispositions",
  initialState: {
    labels: [],
    status: "idle",
    // Optimistic local overrides: { [uniqueId]: {dispositionId, label, color} | null }
    callTags: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDispositions.pending,   (state) => { state.status = "loading"; })
      .addCase(fetchDispositions.fulfilled, (state, action) => {
        state.labels = action.payload;
        state.status = "success";
      })
      .addCase(fetchDispositions.rejected,  (state) => { state.status = "error"; })
      .addCase(createDisposition.fulfilled, (state, action) => {
        state.labels.push(action.payload);
      })
      .addCase(updateDisposition.fulfilled, (state, action) => {
        const idx = state.labels.findIndex((l) => l.id === action.payload.id);
        if (idx !== -1) state.labels[idx] = action.payload;
      })
      .addCase(deleteDisposition.fulfilled, (state, action) => {
        state.labels = state.labels.filter((l) => l.id !== action.payload);
      })
      .addCase(tagCall.fulfilled, (state, action) => {
        const { uniqueId, dispositionId, label, color } = action.payload;
        state.callTags[uniqueId] = { dispositionId, label, color };
      })
      .addCase(untagCall.fulfilled, (state, action) => {
        state.callTags[action.payload] = null;
      });
  },
});

export default dispositionsSlice.reducer;
